/**
 * @copyright (C) Microsoft Corporation.
 * All Rights Reserved.
 */

import { IDropdownOption } from "@fluentui/react";
import { i18n } from "i18next";
import { specialties as specialties_US } from "./specialties_US";
import { specialties as specialties_other } from "./specialties_other";

/**
 * Get the dropdown options for specialties
 * @param t The function to translate.
 * @returns Dropdown options for user specialties.
 */
export const getSpecialtiesOptions = (t: i18n["t"], env?: string): IDropdownOption[] => {
    let specialties;
    if (isUSEnvironment(env)) {
        specialties = specialties_US;
    } else {
        specialties = specialties_other;
    }
    const options: IDropdownOption[] = [{ text: t("Users.Add.Specialty_None"), key: "" }].concat(
        specialties.map(s => {
            return { text: s, key: s };
        })
    );
    return options;
};

const isUSEnvironment = (env?: string): boolean => {
    return us_environments.includes(env?.toLowerCase() || "");
};

const us_environments = ["production", "staging", "development", "qa"];
